<template>
    <div @click.stop="onRadioBoxCheck(folder)" class="radio-button" v-if="selection_box === 'radio'">
        <input :id="folder.id" type="radio" @click.prevent="null" :checked="folders_selection_collection.index[folder.id]" tabindex="-1">
        <label @click.prevent="null" :for="folder.id" tabindex="0"></label>
    </div>

    <div @click.stop="onCheckBoxCheck(folder)" class="checkbox" v-else-if="selection_box === 'check'">
        <input :id="folder.id" type="checkbox" @click.prevent="null" :checked="folders_selection_collection.index[folder.id]" tabindex="-1">
        <label @click.prevent="null" :for="folder.id"></label>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';

  const props = defineProps({
    folders_selection_collection : {
      required: true,
    },

    selection_box : {
      default: null,
    },

    folder : {
      required: true,
    }
  })

  const emit = defineEmits([
   'folderCheckBoxCheck', 'folderRadioBoxCheck',
  ])

  const onCheckBoxCheck = (folder) => {
    emit('folderCheckBoxCheck', folder);
  }

  const onRadioBoxCheck = (folder) => {
    emit('folderRadioBoxCheck', folder);
  }

</script>